import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import Cookies from "js-cookie";
import { createAvroEventsHub } from "@zapier/avro-events";
import { emit } from "@zapier/events-toolkit-browser";

// https://gitlab.com/zapier/avro-schemas/-/blob/main/schemas/billing/account/plan/plan_change_user_interaction_event.avsc
export const PlanChangeUserInteractionEvent = "billing.account.plan.PlanChangeUserInteractionEvent";
export const emitPlanChangeInteractionEvent = async eventDetails => {
  const avroEvent = createAvroEventsHub();
  avroEvent.emitFunction = emit;
  const eventData = _objectSpread(_objectSpread({}, eventDetails), {}, {
    identity_id: Cookies.get("zapidentity"),
    release_id: `${process.env.NEXT_PUBLIC_COMMIT_SHA}`,
    absolute_url: window.location.href,
    timestamp_ms: Date.now()
  });
  return await emit(eventData, PlanChangeUserInteractionEvent);
};
//# sourceMappingURL=emitPlanChangeEvent.js.map
// @zapier/checkout@7.9.7 (23abc9ace)
